// Dependencies
import React from "react";

// Components
import StackedGraphBody from "./PercentageStackedGraphBody";
import StackedGraphLegend from "./PercentageGraphLegend";

//Redux

// Material-UI
import { Box } from "@mui/material";

function PercentageGraph({
  keys,
  data,
  legendData,
  transformLegendText,
  selectedAssignment = {},
  selectedAssignmentData = {},
  clickOnAssignent,
  renderBarLabel = null
}) {
  // Hooks

  // Redux
  // Ephemeral state

  // Behavior
  return (
    <Box
      sx={{
        display: "flex",
        flexFlow: "column nowrap",
        width: "100%",
        height: "100%",
        alignItems: "center"
      }}>
      <StackedGraphBody
        keys={keys}
        data={data}
        selectedAssignment={selectedAssignment}
        clickOnBar={clickOnAssignent}
        renderBarLabel={renderBarLabel}
      />
      <StackedGraphLegend
        legendData={legendData}
        selectedAssignment={selectedAssignment}
        transformLegendText={transformLegendText}
        selectedAssignmentData={selectedAssignmentData}
      />
    </Box>
  );
}

export default PercentageGraph;
